import { render, staticRenderFns } from "./CallRecording.vue?vue&type=template&id=47f4f72d&"
import script from "./CallRecording.vue?vue&type=script&lang=js&"
export * from "./CallRecording.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports